angular.module('mercury.modules.reports', [
  'mercury.modules.reports.dashboard',
  'mercury.modules.reports.discounts',
  'mercury.modules.reports.revenue',
  'mercury.modules.reports.items',
  'mercury.modules.reports.labour',
  'mercury.modules.reports.cogs',
  'mercury.modules.reports.grossprofit',
  'mercury.modules.reports.reconciliations',
  'mercury.modules.reports.sales.worksheet',
  'mercury.modules.reports.staff',
  'mercury.modules.reports.multisite',
  'mercury.modules.reports.transactions',
  'mercury.modules.reports.voids',
  'mercury.modules.reports.refunds'
]);
